import React from 'react'

import { palette } from '../../../styles/variables'
import {
  FlipUnitGroup,
  FlipUnitLabel,
  FlipUnitTime,
  FlipUnitWrapper,
} from '../styled'
import {
  INITIAL_CARD_STYLE,
  INITIAL_DIVIDER_STYLE,
  INITIAL_LABEL_STYLE,
  INITIAL_TEXT_STYLE,
} from '../consts'
import { translate } from '../../../utils/translation'

import { AnimatedCard } from './animatedCard'
import { StaticCard } from './staticCard'

const LABELS = {
  days: 'timer_days',
  hours: 'timer_hours',
  minutes: 'timer_minutes',
  seconds: 'timer_seconds',
}

export const FlipUnitContainer = ({
  digit,
  shuffle,
  unit,
  card = {},
  text = {},
  divider = {},
  label,
  isLast,
  animate = true,
}) => {
  const cardStyle = {
    ...INITIAL_CARD_STYLE,
    ...card,
  }
  const textStyle = {
    ...INITIAL_TEXT_STYLE,
    ...text,
  }
  const dividerStyle = {
    ...INITIAL_DIVIDER_STYLE,
    ...divider,
  }
  const labelStyle = {
    ...INITIAL_LABEL_STYLE,
    ...label,
  }
  const formatDigit = (value) => (value < 10 ? `0${value}` : value.toString())

  const currentDigit = formatDigit(digit)

  const getNextDigit = (_unit, _digit) => {
    switch (_unit) {
      case 'hours':
        return _digit === 23 ? 0 : _digit + 1
      case 'minutes':
      case 'seconds':
        return _digit === 59 ? 0 : _digit + 1
      default:
        return _digit === 0 ? 0 : _digit + 1
    }
  }

  const previousDigit = formatDigit(getNextDigit(unit, digit))

  const [digit1, digit2] = shuffle
    ? [previousDigit, currentDigit]
    : [currentDigit, previousDigit]
  const [animation1, animation2] = shuffle
    ? ['fold', 'unfold']
    : ['unfold', 'fold']

  const bg1 =
    cardStyle?.background?.[0] || cardStyle?.background || palette.orange70
  const bg2 =
    cardStyle?.background?.[1] || cardStyle?.background || palette.orange70

  const renderStaticCard = (position, _digit, charIndex, cardPos) => {
    const background = cardPos === 'top' ? bg1 : bg2
    return (
      <StaticCard
        position={position}
        digit={_digit.charAt(charIndex)}
        background={background}
        textStyle={textStyle}
      />
    )
  }

  const renderAnimatedCard = (_digit, charIndex, animation, cardPos) => {
    let background = bg1
    if (cardPos === 'top' || cardPos === 'bottom') {
      background = animation === 'unfold' ? bg2 : bg1
    }
    return (
      <AnimatedCard
        digit={_digit.charAt(charIndex)}
        animation={animation}
        background={background}
        textStyle={textStyle}
      />
    )
  }

  return (
    <FlipUnitGroup>
      <FlipUnitTime isLast={isLast} {...dividerStyle} gap={cardStyle?.gap}>
        <FlipUnitWrapper {...cardStyle}>
          {renderStaticCard(
            animate ? 'upper-card' : 'full-card',
            currentDigit,
            0,
            'top',
          )}
          {animate &&
            renderStaticCard('lower-card', previousDigit, 0, 'bottom')}
          {animate &&
            renderAnimatedCard(
              digit1,
              0,
              digit1.charAt(0) === digit2.charAt(0) ? 'fold-card' : animation1,
              'top',
            )}
          {animate &&
            renderAnimatedCard(
              digit2,
              0,
              digit1.charAt(0) === digit2.charAt(0)
                ? 'unfold-card'
                : animation2,
              'bottom',
            )}
        </FlipUnitWrapper>
        <FlipUnitWrapper {...cardStyle}>
          {renderStaticCard(
            animate ? 'upper-card' : 'full-card',
            currentDigit,
            1,
            'top',
          )}
          {animate &&
            renderStaticCard('lower-card', previousDigit, 1, 'bottom')}
          {animate && renderAnimatedCard(digit1, 1, animation1, 'top')}
          {animate && renderAnimatedCard(digit2, 1, animation2, 'bottom')}
        </FlipUnitWrapper>
      </FlipUnitTime>
      <FlipUnitLabel {...labelStyle}>{translate(LABELS[unit])}</FlipUnitLabel>
    </FlipUnitGroup>
  )
}
